import { NotificationHandler } from '../notificationHandler/NotificationHandler';

export const TOKEN = 'web-token';

export const getToken = () => {
  return TOKEN
}

export const alertMessage = (type, title, info, placement = '') => {
  const obj = {
    type: type,
    message: title,
    description: info,
    placement: placement ? 'bottomRight' : 'topRight',
    duration: 2
  }
  NotificationHandler(obj);
}